<template>
  <div style="width: 94%; margin-left: 3%">
    <div v-for="(item, i) in items" :key="i + item.key">
      <v-card-text
        class="pa-0"
        :class="isSmallDevice ? 'small-device' : ''"
        style="display: flex; justify-content: space-between; font-weight: bold"
      >
        <v-col
          class="pa-0"
          cols="10"
          style="
            display: inline-flex !important;
            vertical-align: top !important;
            margin-top: 14px !important;
          "
          >{{ item.key }}
        </v-col>
        <v-col
          class="common-toggle pa-0 text-right"
          cols="2"
          style="
            display: inline-flex !important;
            vertical-align: top !important;
            margin-top: 10px !important;
          "
        >
          <v-switch
            v-model="item.value.value"
            color="#00B791"
            class="mt-0"
            value="false"
            @change="encodeSwitch(item.value.value, item.value.key)"
            :disabled="!isClickable"
            style="margin-right: 0 !important; margin-left: auto !important"
            data-cy="ownContainerToggle"
          ></v-switch>
        </v-col>
      </v-card-text>
    </div>
  </div>
</template>
<script>
import Vue from "vue";

export default Vue.extend({
  props: {
    items: Array,
    isClickable: Boolean,
    isSmallDevice: Boolean,
  },
  methods: {
    encodeSwitch(value, dataName) {
      const changedValue = value ? "switch-is-on" : "switch-is-off";
      this.$emit(changedValue, dataName);
    },
  },
});
</script>
<style lang="css" scoped>
.common-toggle > .v-input.v-input--is-label-active >>> .v-input--switch__track {
  opacity: 1 !important;
}
.common-toggle >>> .v-input--switch__thumb {
  color: white !important;
}
.small-device >>> * {
  font-size: 0.8rem;
}
.common-toggle >>> .v-messages {
  display: none !important;
}
.common-toggle {
  height: 40px !important;
}
@media (max-width: 320px) {
  .common-toggle >>> .v-input {
    margin-left: 0 !important;
  }
  * {
    font-size: 0.75rem !important;
  }
}
</style>
